'use strict';
var __extends =
	(this && this.__extends) ||
	(function () {
		var extendStatics = function (d, b) {
			extendStatics =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (d, b) {
						d.__proto__ = b;
					}) ||
				function (d, b) {
					for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
				};
			return extendStatics(d, b);
		};
		return function (d, b) {
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype =
				b === null
					? Object.create(b)
					: ((__.prototype = b.prototype), new __());
		};
	})();
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var CLASS_NAME = 'i-backdrop';
/**
 * Backdrop is used to overlay items in the background to prevent the user clicking them.
 *
 * Also see {{Modal}} and {{Slideout}}.
 */
var Backdrop = /** @class */ (function (_super) {
	__extends(Backdrop, _super);
	function Backdrop() {
		var _this = (_super !== null && _super.apply(this, arguments)) || this;
		_this.addClickListener = function () {
			window.addEventListener('mousedown', _this.handleClick);
		};
		_this.removeClickListener = function () {
			window.removeEventListener('mousedown', _this.handleClick);
		};
		_this.handleClick = function (e) {
			if (
				_this.props.active &&
				(!_this.props.elements ||
					_this.props.elements.every(function (element) {
						return !element.contains(e.target);
					}))
			) {
				_this.props.onClick(e);
			}
		};
		return _this;
	}
	Backdrop.prototype.componentWillMount = function () {
		if (!this.props.isBlocking) {
			this.addClickListener();
		}
	};
	Backdrop.prototype.componentWillReceiveProps = function (nextProps) {
		if (this.props.isBlocking && !nextProps.isBlocking) {
			this.addClickListener();
		}
		if (!this.props.isBlocking && nextProps.isBlocking) {
			this.removeClickListener();
		}
	};
	Backdrop.prototype.componentWillUnmount = function () {
		if (!this.props.isBlocking) {
			this.removeClickListener();
		}
	};
	Backdrop.prototype.render = function () {
		var _a;
		var _b = this.props,
			active = _b.active,
			children = _b.children,
			className = _b.className,
			elements = _b.elements,
			isBlocking = _b.isBlocking,
			isContained = _b.isContained,
			isTinted = _b.isTinted,
			style = _b.style,
			zIndex = _b.zIndex,
			restProps = __rest(_b, [
				'active',
				'children',
				'className',
				'elements',
				'isBlocking',
				'isContained',
				'isTinted',
				'style',
				'zIndex',
			]);
		return React.createElement(
			'div',
			__assign(
				{
					className: classNames(
						CLASS_NAME,
						'modal-backdrop',
						'fade',
						className,
						((_a = {}),
						(_a[CLASS_NAME + '--absolute'] = isContained),
						(_a[CLASS_NAME + '--non-blocking'] =
							!active || !isBlocking),
						(_a.show = active && isTinted),
						_a)
					),
					style: __assign({}, style, { zIndex: zIndex }),
				},
				restProps
			),
			children
		);
	};
	Backdrop.defaultProps = {
		isBlocking: true,
	};
	return Backdrop;
})(React.Component);
exports.Backdrop = Backdrop;
//# sourceMappingURL=Backdrop.js.map
